import { render, staticRenderFns } from "./couponWeappAttr.vue?vue&type=template&id=2b6d57d0&scoped=true"
import script from "./couponWeappAttr.vue?vue&type=script&lang=js"
export * from "./couponWeappAttr.vue?vue&type=script&lang=js"
import style0 from "./couponWeappAttr.vue?vue&type=style&index=0&id=2b6d57d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d57d0",
  null
  
)

component.options.__file = "couponWeappAttr.vue"
export default component.exports